// src/components/EntriesList/HistoryModal.js
import React from 'react';
import { styles } from './styles/entryStyles';

/**
 * Komponente zur Anzeige der Historie eines Eintrags
 */
function HistoryModal({ historyRecords, entryId, onClose }) {
  return (
    <div style={styles.historyModal}>
      <div style={styles.historyModalContent}>
        <h3>Historie für Eintrag {entryId}</h3>
        {historyRecords.length === 0 ? (
          <p>Keine Historie vorhanden.</p>
        ) : (
          <div style={styles.historyTableContainer}>
            <table style={styles.historyTable}>
              <thead>
                <tr>
                  <th style={styles.historyTh}>Altes Datum</th>
                  <th style={styles.historyTh}>Neues Datum</th>
                  <th style={styles.historyTh}>Alte Art</th>
                  <th style={styles.historyTh}>Neue Art</th>
                  <th style={styles.historyTh}>Alter Betreff</th>
                  <th style={styles.historyTh}>Neuer Betreff</th>
                  <th style={styles.historyTh}>Alte Uhrzeit von</th>
                  <th style={styles.historyTh}>Neue Uhrzeit von</th>
                  <th style={styles.historyTh}>Alte Uhrzeit bis</th>
                  <th style={styles.historyTh}>Neue Uhrzeit bis</th>
                  <th style={styles.historyTh}>Alte Stunden</th>
                  <th style={styles.historyTh}>Neue Stunden</th>
                  <th style={styles.historyTh}>Alte Hotelspeesen</th>
                  <th style={styles.historyTh}>Neue Hotelspeesen</th>
                  <th style={styles.historyTh}>Alte Verpflegung</th>
                  <th style={styles.historyTh}>Neue Verpflegung</th>
                  <th style={styles.historyTh}>Alte KundenID</th>
                  <th style={styles.historyTh}>Neue KundenID</th>
                  <th style={styles.historyTh}>Alter Stundensatz</th>
                  <th style={styles.historyTh}>Neuer Stundensatz</th>
                  <th style={styles.historyTh}>Alt Fachgebiet</th>
                  <th style={styles.historyTh}>Neu Fachgebiet</th>
                  <th style={styles.historyTh}>Alt Homeoffice</th>
                  <th style={styles.historyTh}>Neu Homeoffice</th>
                  <th style={styles.historyTh}>Alt Abgerechnet</th>
                  <th style={styles.historyTh}>Neu Abgerechnet</th>
                  <th style={styles.historyTh}>Alter Änderungsgrund</th>
                  <th style={styles.historyTh}>Neuer Änderungsgrund</th>
                  <th style={styles.historyTh}>Alter Änderungstext</th>
                  <th style={styles.historyTh}>Neuer Änderungstext</th>
                </tr>
              </thead>
              <tbody>
                {historyRecords.map(record => (
                  <tr key={record.id}>
                    <td style={{ ...styles.historyTd, ...(record.old_date !== record.date ? styles.changedOld : {}) }}>
                      {record.old_date}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_date !== record.date ? styles.changedNew : {}) }}>
                      {record.date}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_type !== record.type ? styles.changedOld : {}) }}>
                      {record.old_type}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_type !== record.type ? styles.changedNew : {}) }}>
                      {record.type}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_subject !== record.subject ? styles.changedOld : {}) }}>
                      {record.old_subject}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_subject !== record.subject ? styles.changedNew : {}) }}>
                      {record.subject}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_startTime !== record.startTime ? styles.changedOld : {}) }}>
                      {record.old_startTime}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_startTime !== record.startTime ? styles.changedNew : {}) }}>
                      {record.startTime}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_endTime !== record.endTime ? styles.changedOld : {}) }}>
                      {record.old_endTime}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_endTime !== record.endTime ? styles.changedNew : {}) }}>
                      {record.endTime}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_hours !== record.hours ? styles.changedOld : {}) }}>
                      {record.old_hours}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_hours !== record.hours ? styles.changedNew : {}) }}>
                      {record.hours}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_hotelspeesen !== record.hotelspeesen ? styles.changedOld : {}) }}>
                      {record.old_hotelspeesen}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_hotelspeesen !== record.hotelspeesen ? styles.changedNew : {}) }}>
                      {record.hotelspeesen}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_verpflegungsMehraufwand !== record.verpflegungsMehraufwand ? styles.changedOld : {}) }}>
                      {record.old_verpflegungsMehraufwand}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_verpflegungsMehraufwand !== record.verpflegungsMehraufwand ? styles.changedNew : {}) }}>
                      {record.verpflegungsMehraufwand}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_customerID !== record.customerID ? styles.changedOld : {}) }}>
                      {record.old_customerID}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_customerID !== record.customerID ? styles.changedNew : {}) }}>
                      {record.customerID}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_hourlyWage !== record.hourlyWage ? styles.changedOld : {}) }}>
                      {record.old_hourlyWage}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_hourlyWage !== record.hourlyWage ? styles.changedNew : {}) }}>
                      {record.hourlyWage}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_fachgebiet !== record.fachgebiet ? styles.changedOld : {}) }}>
                      {record.old_fachgebiet}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_fachgebiet !== record.fachgebiet ? styles.changedNew : {}) }}>
                      {record.fachgebiet}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_homeoffice !== record.homeoffice ? styles.changedOld : {}) }}>
                      {record.old_homeoffice}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_homeoffice !== record.homeoffice ? styles.changedNew : {}) }}>
                      {record.homeoffice}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_abgerechnet !== record.abgerechnet ? styles.changedOld : {}) }}>
                      {record.old_abgerechnet}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_abgerechnet !== record.abgerechnet ? styles.changedNew : {}) }}>
                      {record.abgerechnet}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_aenderungsGrund !== record.aenderungsGrund ? styles.changedOld : {}) }}>
                      {record.old_aenderungsGrund}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_aenderungsGrund !== record.aenderungsGrund ? styles.changedNew : {}) }}>
                      {record.aenderungsGrund}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_aenderungsText !== record.aenderungsText ? styles.changedOld : {}) }}>
                      {record.old_aenderungsText}
                    </td>
                    <td style={{ ...styles.historyTd, ...(record.old_aenderungsText !== record.aenderungsText ? styles.changedNew : {}) }}>
                      {record.aenderungsText}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div style={{ marginTop: '1rem', textAlign: 'right' }}>
          <button type="button" onClick={onClose} style={styles.cancelBtn}>
            Schließen
          </button>
        </div>
      </div>
    </div>
  );
}

export default HistoryModal;